module.exports = __webpack_public_path__ + "img/code.ea9d175a.png";